<template>
  <div class="modal fade" id="rollOutPromotionEditModal" tabindex="-1" role="dialog" aria-labelledby="rollOutPromotionEditModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="rollOutPromotionEditModalLabel">Edit Roll Out Promotions</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label">Promotion</label>
            <br>
            <input v-model="name" class="form-control">
          </div>
          <div class="form-group">
            <label class="custom-label">Date</label>
            <br>
            <datepicker
              format="dd.MM.yyyy"
              v-model="date"
              :bootstrap-styling="true"
              input-class="bg-white"
            />
          </div>
          <div class="form-group">
            <label class="custom-label">Description</label>
            <br>
            <textarea class="form-control" rows="5" v-model="description"></textarea>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: space-between;">
          <button type="button" class="btn btn-primary" @click="addPromotion">Save</button>
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['rollOutId', 'promotion'],
    data() {
      return {
        name: this.promotion.name,
        date: this.promotion.date,
        description: this.promotion.description,
      }
    },
    methods: {
      addPromotion() {
        window.axios.put(`/roll_outs/${this.rollOutId}/roll_out_promotions/${this.promotion.id}`, {
          name: this.name,
          date: this.date ? moment(this.date).format('YYYY-MM-DD') : '',
          description: this.description,
        }).then(({data}) => {
          this.$emit('updated', data)
        })
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/RollOutPromotionEditModal.vue